module.exports = __webpack_public_path__ + "img/8.7b5fe8b7.png";